import "./Sidebar.scss";
import React from "react";
import { Col, Icon, Badge } from "antd";
import { useTranslation } from 'react-i18next';

const Sidebar = ({ client, currentUser, activeTab, onTabChange, edoTasks }) => {
  const {t} = useTranslation()
  return (
    <Col className="sidebar" span={5}>
      <div className="sidebar-inner">
        <div className="menu-block">
          <ul>
            {client?.modules.includes("CDI-FORM") && (
              <>
                <h3>{t('messages.aml.modulesNames.cdi')}</h3>
                <li
                  className={
                    activeTab === "tab-newdeclaraciones" ? "active" : ""
                  }
                  onClick={() => onTabChange("tab-newdeclaraciones")}
                >
                  <div className="menu-item-inner">
                    {t('messages.aml.report.type.DECL')}
                    <Icon type="check" />
                  </div>
                </li>
              </>
            )}

            {client?.modules.includes("ADMCLI") && currentUser.type === 'Entity' &&
              <>
                <h3>{t('messages.aml.report.type.UBOS')}</h3>
                <li
                  className={
                    activeTab === "tab-beneficiarios-finales" ? "active" : ""
                  }
                  onClick={() => onTabChange("tab-beneficiarios-finales")}
                >
                  <div className="menu-item-inner">
                    {t('messages.aml.ubofinder.c57forms')}
                    <Icon type="check" />
                  </div>
                </li>
              </>
            }

            {client?.modules.includes("MONITOR") && edoTasks !== null && (
              <>
                <h3>{t('messages.aml.monitoring')}</h3>
                {Object.entries(edoTasks).map(([key, val]) => (
                  <li key={val}
                    className={activeTab === "tab-tasks-" + key ? "active" : val === 0 ? "disabled-tab":""}
                    onClick={val > 0 ?(() => onTabChange("tab-tasks-" + key)) : null}
                  >
                    <div className="menu-item-inner">
                      <span>{t("messages.aml.tasks."+key)}</span>
                      <Badge count={val} size="small" showZero/>
                      <Icon type="check" />
                    </div>
                  </li>
                ))}
              </>
            )}

          {/* INICIO TABS DE ONBOARDING */}
            {client?.modules.includes("ONBOARDING") && (
              <>
                <h3>OnBoarding</h3>
                <li
                  className={ activeTab === "tab-onboarding" ? "active" : "" }
                  onClick={() => onTabChange("tab-onboarding")}
                >
                  <div className="menu-item-inner">
                    <Icon type="form" className="option"/>
                    {t('messages.aml.ubofinder.forms')}
                    <Icon type="check" />
                  </div>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </Col>
  );
};

export default Sidebar;
